define('viewmodels/pages/unsubscribe',['knockout'], function (ko) {

    var UnsubscribeViewModel = function(
        session,
        players,
        NotificationModel,
        tagManager,
        UnsubscribeCommand,
        loginPageField,
        unsubscribePageField
    ) {
        var self = this;

        self.playerId = ko.observable();
        self.unsubscribed = ko.observable(false);
        self.unsubscribeCommand = new UnsubscribeCommand({ playerId: self.playerId });

        self.logInLinkText = loginPageField('log_in_link_text');
        self.title = unsubscribePageField('title');
        self.description = unsubscribePageField('description');
        self.buttonText = unsubscribePageField('button_text');
        self.imageUrl = unsubscribePageField('image');

        self.onUnsubscribe = function() {
            session.getAssociatedPlayer().notifications.addNotification(new NotificationModel('unsubscribed'));
            self.unsubscribed(true);
            tagManager.trackEvent('unsubscribe', { userId: self.playerId() });
        };
    };

    UnsubscribeViewModel.prototype.activate = function(playerId) {
        var self = this;

        self.playerId(playerId);
    };

    return UnsubscribeViewModel;
});
